import { render, staticRenderFns } from "./EducationalGroupAttendanceUpdate.vue?vue&type=template&id=24d8c339&"
import script from "./EducationalGroupAttendanceUpdate.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAttendanceUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports